export default [
  {
    name: 'project_donate_field',
    component_path: 'modules/templates/blocks/project/ProjectDonateField'
  }
]